module.exports = __webpack_public_path__ + "img/have-ed-number.93802542.png";